module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-action-buttons"
  }, [_c('div', {
    staticClass: "flex-container flex-dir-column"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openUrl(_vm.attachmentUrl)
      }
    }
  }, [_vm._v("Download")]), _c('a', {
    staticClass: "alert-text",
    on: {
      "click": _vm.deletec
    }
  }, [_vm._v("Delete")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c07612b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/DriverLicenseAttachmentActionButtons.vue
// module id = 2282
// module chunks = 1